const validate = {
  rules: {
    nome: {
      required: true,
    },
    email: {
      required: true,
      email: true,
    },
  },
  messages: {
    nome: "O nome é obrigatório.",
    email: {
      required: "O email é obrigatório.",
      email: "O email é inválido.",
    },
  },
};

export default validate;
